<template>
  <div>
    <!-- Toolbar -->
    <v-toolbar dense tabs color="primary darken-2" dark>
      <v-toolbar-title class="pl-2">Create Business Account</v-toolbar-title>
    </v-toolbar>

    <!-- Main Container -->
    <v-container>
      <v-layout row>
        <v-flex xs12 md8 lg6 offset-md2 offset-lg3>
          <v-slide-y-transition mode="out-in">
            <div>
              <!-- Form Title -->
              <h2 class="blue white--text font-weight-bold subheading pa-2 text-xs-left">
                Create Your Business Account
              </h2>
              <v-divider></v-divider>

              <!-- Business Account Form -->
              <v-card color="white pa-3 pt-1">
                <v-layout row>
                  <v-flex xs12 md10 offset-md1>
                    <!-- Name Field -->
                 
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-user fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.name"
                          label="Full  Name"
                          outlined
                          clearable
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Username Field (Required) -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-user-circle fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.username"
                          label=" Enter your Username"
                          :rules="[v => !!v || 'Username is required']"
                          outlined
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Password Field -->
                    <v-layout row>
                    <v-flex xs2 sm1>
                    <i class="teal--text fas fa-lock fa-2x mt-2"></i>
                    </v-flex>
                    <v-flex xs10 sm10>
                    <v-text-field
                    :append-icon="e1 ? 'visibility_off' : 'visibility'"
                    @click:append="() => (e1 = !e1)"
                    :type="e1 ? 'text' : 'password'"
                      v-model="form.password"
                      label="Password"
                      :rules="passwordRules"
                      outlined
                      dense
                    ></v-text-field>
                    </v-flex>
                    </v-layout>

                    <!-- Telephone Field (Required) -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-phone fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.telephone"
                          label="Phone Number"
                          :rules="phoneRules"
                          outlined
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Email Field -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-envelope fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.email"
                          label="Email Address"
                          :rules="emailRules"
                          outlined
                          required
                          ref="emailField"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Affiliate Referral Field (nouveau système) -->
                    <div class="name-fields">
                      <ReferralField
                        v-model="referralCode"
                        :state="referralState"
                        :ownerName="referralOwnerName"
                        :locked="referralLocked"
                        @input="onReferralInput"
                      />
                    </div>
                  </v-flex>
                </v-layout>

                <!-- Submit Button -->
                <div class="text-xs-right">
                  <v-btn
                    color="teal darken-2"
                    class="white--text"
                    @click="submitForm"
                    small
                    round
                  >
                    Next
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog width="500px" v-model="showPayment"> 
  <v-card> 
    <v-card-title class="headline primary darken-2 white--text" primary-title>
      Confirm Deposit
    </v-card-title> 
    
    <v-card-text class="pa-4">
      <div class="name-fields">
        <div class="name-fields">
          <v-layout row>
              <v-flex xs2 sm1>
                <i class="teal--text fas fa-phone fa-2x mt-2"></i>
              </v-flex>
              <v-flex xs10 sm10>
                <input 
                  id="transactionPhone" 
                  type="tel" 
                  @click="clearTransactionPhoneField()" 
                  class="py-2 my-2" 
                  style="width: 100%!important; border-bottom: 1px grey solid" 
                />
              </v-flex>
              <v-flex xs1>
                <v-btn 
                  @click.stop="$store.commit('activateDialog', true); phone_number_help = true; getSignUpFieldHelp()"
                  flat fab small outline color="black" 
                  class="my-3" 
                  style="height:20px; width: 20px"
                >
                  <i class="fas fa-question"></i>
                </v-btn>
              </v-flex>
            </v-layout>
        </div>        </div>
      <v-layout row wrap class="mb-4">
        <v-flex xs6 class="text-center">
          <v-card 
            @click="selectOperator('MTN')"
            :class="{ 'selected-operator': paymentMethod === 'MTN' }"
            class="pa-2 operator-card"
          >
            <v-img
              :src="require('@/assets/mtn-mobile-money-logo.png')"
              contain height="60"
            ></v-img>
          </v-card>
        </v-flex>
        
        <v-flex xs6 class="text-center">
          <v-card 
            @click="selectOperator('OM')"
            :class="{ 'selected-operator': paymentMethod === 'OM' }"
            class="pa-2 operator-card"
          >
            <v-img
              :src="require('@/assets/om.png')"
              contain height="60"
            ></v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <p class="mb-0">
        By clicking <b class="teal--text darken-2">Confirm</b>, a deposit transaction of 
          <b>10500 F CFA</b> will be triggered through 
          <b v-if="paymentMethod">{{ paymentMethod === 'MTN' ? 'MTN Mobile Money' : 'Orange Money' }}</b>
          <b v-else class="red--text">[ select payment method]</b>
          from the phone number <b>{{ transactionPhoneNumber }}</b>
          <b v-if="!transactionPhoneNumber" class="red--text">[phone number]</b>
        </p>

      <div v-if="paymentMethod" class="mt-3">
        <p class="mb-0">If you are facing difficulties, send manually through the code below:</p>
        <p class="pl-2 mb-0 pt-1 red--text">
          - <b>{{ ussdCode }}</b>
          <v-btn 
            icon 
            @click="copyUSSD"
            class="ml-2"
            title="Copy USSD code"
          >
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
        </p>
        
        <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'MTN'">
          - Choose reference 1
        </p>
        <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'OM'">
          - Input transaction amount
        </p>
        <p class="pl-2 mb-0 pt-1">
          - Always <b class="teal--text darken-2">Confirm</b> below
        </p>


      </div>
    </v-card-text>

<v-card-actions class="px-3"> 
  <v-btn color="teal" text @click="showPayment = false">Cancel</v-btn> 
  <v-spacer></v-spacer> 
  <v-btn 
  color="teal darken-2" 
  class="white--text" 
  @click="handlePaymentConfirmation"
  :disabled="!paymentMethod || !transactionPhoneNumber"
  :loading="processingPayment"
>
  Confirm
</v-btn>
</v-card-actions>
  </v-card> 
</v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import referralMixin from '@/mixins/referralMixin';
import ReferralField from '@/components/ReferralField.vue';

export default {
  mixins: [referralMixin],
  components: { ReferralField },
  data() {
    return {
      e1: true,
      form: {
        name: '',
        username: '',
        telephone: '',
        password: '',
        email: '',
        affiliate_referral: '',
      },
      showPayment: false,
      paymentMethod: '',
      transactionPhoneNumber: '',
      transactionId: '',
      ussdCode: '',
      ussdCode2: '',
      hrefTel: '',
      transfer_code : '',
      
      processingPayment: false,
      usernameRules: [
        v => !!v || 'Username is required',
        v => (v && v.length >= 4) || 'Username must be at least 4 characters',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters',
      ],
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid',
      ],
      phoneRules: [
        v => !!v || 'Phone number is required',
        v => /^[0-9]{9}$/.test(v) || 'Phone number must be 9 digits',
      ],
      
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  mounted() {
  this.form.affiliate_referral = this.$route.query.referral || '';
},
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },            async submitForm() {
  // Helper function to show errors
  const showValidationError = (message) => {
    this.$store.commit('setSnackBarMessage', message);
    this.$store.commit('setSnackBarColor', 'red darken-4');
    this.$store.commit('activateSnackBar', true);
  };

  // Validations
  if (this.form.name.length < 2) { // Check for at least 2 names
    showValidationError('Your name is too short, please input at least 2 of your names');
    return;
  }

  if (this.form.username.length < 4) {
    showValidationError('Username is too short, needs to be at least 4 characters');
    return;
  }

  if (this.form.password.length < 8) {
    showValidationError('Password is too short, needs to be at least 8 characters');
    return;
  }

  if (!this.form.email) {
    showValidationError('Email is required');
    return;
  }

  // Better email regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(this.form.email)) {
    showValidationError('Email must be valid');
    return;
  }

  if (!this.phoneInput?.isValidNumber?.()) { // Optional chaining for safety
    showValidationError('Phone number is invalid. Please input a valid number');
    return;
  }

  try {
    const response = await axios.post('/api/v1/home/validate-credentials/', {
      username: this.form.username,
      phone: this.phoneInput.getNumber(),
      password: this.form.password
    });

    // Handle API response errors
    if (response.data?.error) {
      this.showError(response.data.error);
      return;
    }

    // Show payment section
    this.showPayment = true;
    this.$store.commit('setSnackBarMessage', 'Please enter your transaction number and select the payment method between Orange Money or MTN Momo.');
    this.$store.commit('setSnackBarColor', 'teal darken-2');
    this.$store.commit('activateSnackBar', true);

    // Reset payment fields
    this.paymentMethod = '';
    this.ussdCode = '';
    this.transactionId = '';
    this.transactionPhoneNumber = '';

  } catch (error) {
    // Handle network errors and server errors
    const errorMessage = error.response?.data?.error || 'An unexpected error occurred';
    this.showError(errorMessage);
  }
},

showError(message) {
  this.$store.commit('setSnackBarMessage', message);
  this.$store.commit('setSnackBarColor', 'red darken-4');
  this.$store.commit('activateSnackBar', true);
},


    selectOperator(operator) {
      this.paymentMethod = operator;
      this.generateUSSD();
      this.transactionId = this.generateTransactionId();
      this.showSnackbar(`Selected payment method: ${operator === 'MTN' ? 'MTN Mobile Money' : 'Orange Money'}`, 'info');
    },

    generateTransactionId() {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 1000);
      return `${this.paymentMethod}-${timestamp}-${random}`;
    },
    generateUSSD() {
  const amount = 10500; 


  if (this.paymentMethod === "MTN") {
    this.ussdCode = `*126*4*${this.$store.state.MerchantCodeMTN}*${amount}#`;
    this.transfer_code = `*126*4*${this.$store.state.MerchantCodeMTN}*${amount}%23`;
    this.hrefTel = `tel:*126*4*${this.$store.state.MerchantCodeMTN}*${amount}%23`;
  } else if (this.paymentMethod === "OM") {
    this.transfer_code = `%23150*47*${this.$store.state.MerchantCodeOrange}*${amount}%23`;
    this.ussdCode = `#150*47*${this.$store.state.MerchantCodeOrange}*${amount}#`;
    this.hrefTel = `tel:%23150*47*${this.$store.state.MerchantCodeOrange}*${amount}%23`;
  }


  

  const dialLink = document.getElementById('dial_transaction');
  if (dialLink) {
    dialLink.setAttribute('href', this.hrefTel);
    dialLink.setAttribute('target', '_blank');
  }
},

async handlePayment() {
  if (!this.transactionPhoneNumber) {
    this.showSnackbar('Please enter payment phone number', 'error');
    this.$store.commit("Please enter payment phone number");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);
    return;
  }

  if (!this.paymentMethod) {
    this.showSnackbar('Please select payment operator', 'error');
    this.$store.commit("Please select payment operator");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);
    return;
  }

  if (!this.transactionPhoneNumber.match(/^[0-9]{9}$/)) {
    this.showSnackbar('Invalid phone number format (9 digits required)', 'error');
    this.$store.commit("Invalid phone number format (9 digits required)");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);

    return;
  }
 
  try {
    this.generateUSSD();
    this.showSnackbar('Payment interface opening...', 'info');
    
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = this.hrefTel;
    } else {
      const win = window.open('', '_blank');
      win.location = this.hrefTel;
    }
    
    
    // Générer l'ID de transaction
    this.transactionId = this.generateTransactionId();

    
  } catch (error) {
    this.showSnackbar('Payment initiation failed: ' + error.message, 'error');
  }
},

async handlePaymentConfirmation() {
      if (!this.paymentMethod) {
        this.showSnackbar('Please select payment operator', 'error');
        return;
      }
      if (!this.transactionPhoneInput?.isValidNumber()) {
    this.$store.commit('setSnackBarMessage', "Phone number is invalid. Please input a valid number");
    this.$store.commit('setSnackBarColor', "red darken-4");
    this.$store.commit('activateSnackBar', true);
        return;
      }
      
      try {
        this.generateUSSD();
        window.location.href = this.hrefTel;
    
    
    await this.confirmPayment();

   
    setTimeout(() => {
      if (!document.hidden) {
        window.open(this.hrefTel, '_blank');
      }
    }, 200);

      } catch (error) {
        this.showSnackbar(error.message, 'error');
      }
    },

    openPaymentInterface() {
      try {
        const opener = this.isMobile ? window.location.href = this.hrefTel : window.open(this.hrefTel, '_blank');
        this.showSnackbar('Payment interface opening...', 'info');
        return opener;
      } catch (error) {
        throw new Error('Failed to open payment interface');
      }
    },
    async confirmPayment() {
      this.processingPayment = true;
      
      try {
        const response = await axios.post('/api/v1/savings/business-account/', this.createPayload());
        
        if (!response.data.success) {
          this.$store.commit('setSnackBarMessage', "Please check your password and username are the same as the ones used in your PettyCash account....");
          this.$store.commit('setSnackBarColor', "teal darken-2");
          this.$store.commit('activateSnackBar', true);
        }
        
        await this.handleSuccessFlow(response);
      } catch (error) {
        this.handleApiError(error);
        throw error;
      } finally {
        this.processingPayment = false;
      }
    },

    createPayload() {
      return {
        username: this.form.username,
        password: this.form.password,
        phone_number: this.form.telephone,
        payment_method: this.paymentMethod,
        email: this.form.email,
        transaction_id: this.transactionId,
        transaction_phone: this.transactionPhoneNumber,
        serial_no: this.getReferralPayload()
      };
    },

    async handleSuccessFlow(_response) {
      this.showSuccessMessage();
      await this.handleAutoLogin();
      this.redirectToCampaign();
    },

    showSuccessMessage() {
      this.$store.commit('setSnackBarMessage', "🎉 Your account has been successfully created! You will receive a confirmation email after verification. Redirecting...");
      this.$store.commit('setSnackBarColor', "teal darken-2");
      this.$store.commit('activateSnackBar', true);
    },

    async handleAutoLogin() {
      try {
        const { data } = await axios.post('/api/v1/token/login/', {
          username: this.form.username,
          password: this.form.password
        });
        
        this.$store.commit('setToken', data.auth_token);
        axios.defaults.headers.common['Authorization'] = "Token " + data.auth_token;
        localStorage.setItem('token', data.auth_token);
      } catch (error) {
        this.handleLoginError(error);
        throw new Error('Auto-login failed');
      }
    },

    redirectToCampaign() {
      setTimeout(() => {
        this.$router.push({
          path: '/savings/campaigns/create/new_campaign',
          query: {
            username: this.form.username,
            password: this.form.password
          }
        });
        this.resetForm();
        this.showPayment = false;
      }, 6000);
    },

    handleLoginError(error) {
      if (error.response) {
        const errors = error.response.data;
        for (const property in errors) {
          this.showSnackbar(errors[property][0], 'error');
        }
      } else {
        this.showSnackbar("An error occurred while logging in", 'error');
      }
    },

    copyUSSD() {
      navigator.clipboard.writeText(this.ussdCode);
      this.showSnackbar('USSD code copied to clipboard!', 'success');
    },

    resetForm() {
      this.form = {
        name: '',
        username: '',
        telephone: '',
        email: '',
        affiliate_referral: '',
      };
      this.transactionPhoneNumber = '';
    },

    showSnackbar(message, type) {
      this.$store.dispatch('showSnackbar', {
        message,
        color: type === 'error' ? 'red' : 'green',
        timeout: 3000
      });
    },

    handleApiError(error) {
      const message = error.response?.data?.error || 'An error occurred';
      this.showSnackbar(message, 'error');
      console.error('API Error:', error.response?.data || error.message);
    }
  }
};
</script>

<style scoped>
.selected-operator {
  border: 2px solid #009688 !important;
  background-color: #e0f2f1 !important;
}

.operator-card {
  cursor: pointer;
  transition: transform 0.3s ease;
  border: 2px solid transparent;
}

.operator-card:hover {
  transform: scale(1.05);
}

.instruction-list div {
  display: flex;
  align-items: center;
  margin: 8px 0;
  font-size: 0.9rem;
}

.v-alert--info {
  background-color: #e3f2fd !important;
  border-left: 4px solid #2196F3;
}

.v-text-field--readonly .v-input__slot {
  background-color: #f5f5f5 !important;
}

a[href^="tel:"] {
  color: inherit;
  text-decoration: none;
  font-family: monospace;
}

@media (max-width: 600px) {
  .v-dialog {
    margin: 0 !important;
    border-radius: 0 !important;
  }
  
  .v-card__title {
    font-size: 1.5rem !important;
    padding: 12px !important;
  }
  
  .operator-card {
    margin: 5px !important;
  }
}
/* Ajouter dans les styles */
.v-snack__wrapper {
  max-width: 400px !important;
  word-break: break-word;
}

.payment-redirect-message {
  background-color: #e3f2fd !important;
  border-left: 4px solid #2196F3;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 4px;
}

/* Ajouter dans les styles */
.phone-button {
  transition: all 0.3s ease;
}

.phone-button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.fa-phone {
  font-size: 1.5em;
}
.v-input--is-disabled .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}
.v-input__append-inner {
  padding-left: 8px;
}

.optional-field {
  border-left: 3px solid #009688;
  padding-left: 8px;
  margin: 10px 0;
}  .masked-password input {
  -webkit-text-security: disc; /* Masque les caractères pour WebKit */
  text-security: disc; /* Standard futur */
}


/* Solution de repli pour Firefox */
@-moz-document url-prefix() {
  .masked-password input[type="text"] {
    font-family: monospace !important;
    font-size: 0.8em !important;
    letter-spacing: 0.2em;
  }
}
</style>